import routes from 'app/company-dashboard/routes';

export default {
  routes,
};
